/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_TitleInputs */

const en_cp_cal_title = /** @type {(inputs: Cp_Cal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 weeks that fit one semester`)
};

const id_cp_cal_title = /** @type {(inputs: Cp_Cal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 minggu yang muat di satu semester`)
};

/**
* | output |
* | --- |
* | "14 weeks that fit one semester" |
*
* @param {Cp_Cal_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_title = /** @type {((inputs?: Cp_Cal_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_title(inputs)
	return en_cp_cal_title(inputs)
});